// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as GemDodecaExtended } from '../../../../../ui-v3/src/assets/icons/extended/entities/gem-dodeca.svg?react';
import { createIcons } from '../../Icon';
const GemDodecaIcon = /* @__PURE__ */ createIcons('GemDodeca', {
    extended: GemDodecaExtended
});
GemDodecaIcon.supportedTypes = [
    'extended'
];
GemDodecaIcon.category = 'entities';
export default GemDodecaIcon;
